import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../images/back.svg";
import { Button } from "antd";
import { IMAGE_BASE_URL } from "../../../common/Constants";
import axios from "../../../axios/axios";
import { useEffect, useState } from "react";
import SignRemotely from "../../LoanApplication/modals/SignRemotely";
import FlooringSignatureComponent from "../flooringSignatureComponent";
import { toast } from "react-toastify";
import PdfViewer from "../../../components/PDFViewer/PDFViewer";
import { handleDownload } from "../../../common/Utilities";
import { FlooringPdfBaseUrl } from "../../../common/Constants";

const PreviewAAF = () => {
  const accessToken = localStorage.getItem("dealerModuleToken");

  const navigate = useNavigate();
  const location = useLocation();
  const floorData = location.state.floorData;
  // console.log("floorData", floorData)

  const AppId = floorData?.vehicleInfo?.id;
  const dataObj = location.state.dataObj;
  const SelectedAgent = floorData?.cart
    ?.filter((it) => it?.agent?.agent_approved_status == 1)
    .pop();
  // console.log("--------->", SelectedAgent)
  const AgentId = SelectedAgent?.agent?.id;

  const VehicleInfo = floorData?.vehicleInfo;
  const DealerInfo = floorData?.dealer_info;
  const [flooringSettingsData, setFlooringSettingsData] = useState({});
  const [signatureUpload, setSignatureUpload] = useState(false);
  const [remoteSignature, setRemoteSignature] = useState(false);
  const [signatureHolder, setSignatureHolder] = useState("");
  const [signatureHolderId, setSignatureHolderId] = useState("");

  const Reset = () => {
    setSignatureHolder("");
    setSignatureUpload(false);
    setRemoteSignature(false);
  }

  const handleSaveSignature = async (dataUrl, stampUrl) => {
    const dataObj = {
      agent_id: SelectedAgent?.agent_id,
      dealer_approved_status: 1,
      dealer_signature: dataUrl,
      dealer_stamp: stampUrl,
    };
    const resp = await axios.post(
      `flooring/application/approvalStatus/${VehicleInfo?.id}`, dataObj,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (resp.status < 400) {
      toast.success(resp.data?.message);
      navigate("/flooring-cases")
      Reset();
    }
  };
  const UndoConfirmation = async () => {
    // console.log("incoming>>>>>>>>")
    const dataObj = {
      agent_id: SelectedAgent?.agent_id,
      dealer_approved_status: 0,
      dealer_signature: [],
      dealer_stamp: [],
    };
    const resp = await axios.post(
      `flooring/application/approvalStatus/${VehicleInfo?.id}`, dataObj,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    // console.log("after accepted================", resp)
    if (resp.status < 400) {
      toast.success(resp.data?.message);
      navigate("/flooring-cases")
      Reset();
    }
  }

  const GetOwnerType = (item, val) => {
    const temp = flooringSettingsData[`${item}`]?.filter(
      (it) => it.value == val
    );
    if (temp?.length > 0) {
      return temp[0]?.label;
    } else {
      return "";
    }
  };

  const GetFlooringSettings = async () => {
    const resp = await axios.get("/flooring/settings");
    if (resp.status < 400) {
      setFlooringSettingsData(resp.data?.data);
    }
  };

  useEffect(() => {
    GetFlooringSettings();
  }, []);

  return (
    <section className="common_container">
      <header className="common-header flex justify-between flex-wrap gap-4">
        <div className="common-header-body">
          <h1 className=" flex items-center gap-3">
            <span
              className="cursor-pointer"
              onClick={() => {
                navigate("/flooring-cases/view", {
                  state: location.state.returnState,
                });

              }}
            >
              <BackIcon />
            </span>
            Flooring Cases
          </h1>
        </div>
      </header>

      <PdfViewer
        AppId={AppId}
        AgentId={AgentId}
        title="AAF Document"
        type="AAF"
      />
      <section className="approval-advice-footer">
        <Button
          onClick={() => {
            handleDownload(
              `${FlooringPdfBaseUrl}${AppId}/${AgentId}`
            );
          }}
          type="submit" className="sav_btn"
        >
          Download
        </Button>
        {!(SelectedAgent?.agent?.disbursement !== undefined) && (

          <Button
            className="sav_btn"
            onClick={(e) => {
              if (SelectedAgent?.agent?.dealer_approved_status == 1) {
                console.log("check>>>>>>>>")
                UndoConfirmation();
              } else {
                console.log("fgfggdgdgdgdgdg//////////////")
                e.preventDefault();
                setSignatureHolder("applicant");
                setSignatureUpload(true);
              }
            }}
            disabled={SelectedAgent?.agent?.disbursement !== undefined}
          >
            {SelectedAgent?.agent?.dealer_approved_status == 1 ? "Undo Confirmation" : "Sign and Confirm"}
          </Button>
        )}
      </section>
      <FlooringSignatureComponent
        visible={signatureUpload}
        onCancel={() => {
          setSignatureUpload(false);
        }}
        onSave={handleSaveSignature}
        signatureHolder={signatureHolder}
        holderType={"Flooring-Dealer"}
      />
      <SignRemotely
        open={remoteSignature}
        close={() => {
          setRemoteSignature(false);
        }}
        applicationId={localStorage.getItem("applicationno")}
        holderId={signatureHolderId}
        holderType={signatureHolder}
        name={"Test"}
        index={0}
      />
    </section>
  );
};

export default PreviewAAF;


